export default "__VITE_PUBLIC_ASSET__7b0bc835__"